import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { joinAbsRoute } from 'src/common/utils'
import { useStyles } from './styles'

interface ILogNavigationButton {
  route: string
  label: string
}

interface INavigationButtons {
  items: ILogNavigationButton[]
}

const LogNavigationButtons = ({ items }: INavigationButtons) => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const classes = useStyles()

  const handleNavigate = (route: string) => () => navigate(joinAbsRoute(route))

  return (
    <div className={classes.wrapper}>
      {items.map(({ route, label }) => (
        <Button
          key={route}
          type="button"
          onClick={handleNavigate(route)}
          variant="contained"
          color="secondary"
          className={classes.navigateButton}
        >
          {t(label)}
        </Button>
      ))}
    </div>
  )
}

export { LogNavigationButtons }
